import { ChangeDetectorRef, Injectable, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Injectable()
@Pipe({
  name: 'translateLabels',
  standalone: true,
  pure: false,
})
export class TranslateLabelsPipe implements PipeTransform, OnDestroy {
  value: any = '';
  lastInput: any = null;
  onTranslationChange: Subscription | undefined;
  onLangChange: Subscription | undefined;
  onDefaultLangChange: Subscription | undefined;

  constructor(
    private translate: TranslateService,
    private _ref: ChangeDetectorRef
  ) {}

  updateValue(input: any): void {
    if (Array.isArray(input)) {
      this.value = input.map(item => {
        if (item && typeof item === 'object' && ('label' in item || 'name' in item)) {
          return {
            ...item,
            ...(item.label && { label: this.translate.instant(item.label) }),
            ...(item.name && { name: this.translate.instant(item.name) }),
          };
        }
        return item;
      });
    } else if (input && typeof input === 'object' && ('label' in input || 'name' in input)) {
      this.value = {
        ...input,
        ...(input.label && { label: this.translate.instant(input.label) }),
        ...(input.name && { name: this.translate.instant(input.name) }),
      };
    } else {
      this.value = input;
    }
    this._ref.markForCheck();
  }

  transform(input: any): any {
    if (!input) {
      return input;
    }
    if (JSON.stringify(input) === JSON.stringify(this.lastInput)) {
      return this.value;
    }
    this.lastInput = JSON.parse(JSON.stringify(input));
    this.updateValue(input);
    this._dispose();
    this.onTranslationChange = this.translate.onTranslationChange.subscribe(() => this.updateValue(input));
    this.onLangChange = this.translate.onLangChange.subscribe(() => this.updateValue(input));
    this.onDefaultLangChange = this.translate.onDefaultLangChange.subscribe(() => this.updateValue(input));
    return this.value;
  }

  private _dispose(): void {
    this.onTranslationChange?.unsubscribe();
    this.onTranslationChange = undefined;
    this.onLangChange?.unsubscribe();
    this.onLangChange = undefined;
    this.onDefaultLangChange?.unsubscribe();
    this.onDefaultLangChange = undefined;
  }

  ngOnDestroy(): void {
    this._dispose();
  }
}
